;(function ($, window, document) {
  function onDOMContentLoaded() {
    function debounce(fn, delay) {
      let timer = null
      return function () {
        var context = this,
          args = arguments
        clearTimeout(timer)
        timer = setTimeout(function () {
          fn.apply(context, args)
        }, delay)
      }
    }

    function adjust() {
      var $bottomNav = $('#bottom-nav')
      var $sections = $('.bottom-nav__nav__section')
      if (
        typeof $bottomNav !== 'undefined' &&
        typeof $bottomNav[0] !== 'undefined' &&
        $bottomNav[0].clientWidth < 768
      ) {
        $sections.find('ul').removeClass('in')
        var $dropdownElements = $sections.find(
          '.bottom-nav__nav__section__title',
        )
        $dropdownElements
          .filter(function () {
            return $(this).hasClass('hasChildren')
          })
          .on('click', function (e) {
            e.preventDefault()
          })
          .attr('data-toggle', 'collapse')
      } else {
        $sections.find('ul').addClass('in')
        $sections
          .find('.bottom-nav__nav__section__title')
          .off('click')
          .removeAttr('data-toggle')
      }
    }

    $(window).on(
      'resize',
      debounce(function () {
        var width = $(window).width()
        if ($(this).width() != width) {
          adjust()
        }
      }, 150),
    )

    // adjust when document is ready
    adjust()
  }
  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  } else {
    onDOMContentLoaded()
  }
})(jQuery, window, document)
